import { styled } from '@mui/material/styles';
import { Button, Select, Divider, Tabs, Dialog, DialogContent, DialogActions } from '@mui/material';

export const StyledDialog = styled(Dialog)({
  '& .MuiDialog-paper': {
    height: 'min(85vh, 800px)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  }
});

export const DialogTabs = styled(Tabs)(({ theme }) => ({
  flexShrink: 0,
  borderBottom: `1px solid ${theme.palette.divider}`,
  '& .MuiTab-root': {
    fontWeight: 600,
    textTransform: 'none'
  }
}));

export const TabDialogContent = styled(DialogContent)(({ theme }) => ({
  flex: 1,
  overflowY: 'auto',
  overflowX: 'hidden',
  paddingTop: theme.spacing(2)
}));

export const TabDialogActions = styled(DialogActions)(({ theme }) => ({
  flexShrink: 0,
  paddingTop: 0,
  paddingBottom: theme.spacing(2)
}));

export const InviteButton = styled(Button)({
  textAlign: 'center',
  whiteSpace: 'nowrap',
  backgroundColor: '#46D090',
  color: '#FFFFFF',
  '&:hover': {
    backgroundColor: '#2e885b'
  }
});

export const LanguageSelect = styled(Select)(({ theme }) => ({
  '& fieldset': {
    border: 'none',
  },
  '&:hover fieldset': {
    border: 'none',
  },
  '&.Mui-focused fieldset': {
    border: 'none',
  },
  '& .MuiSelect-icon': {
    color: theme.palette.black.main,
  },
  fontWeight: '600'
}));

export const RoleSelect = styled(Select)(({ theme }) => ({
  borderColor: theme.palette.text.secondary,
  color: theme.palette.text.secondary,
  borderStyle: 'solid',
  borderWidth: '1px',
  borderTopLeftRadius: '25px',
  borderTopRightRadius: '25px',
  borderBottomLeftRadius: '25px',
  borderBottomRightRadius: '25px',
  width: '80%',
  textAlign: 'center',
  height: '40px',
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3)
})); 